import { AccessCheckDropdownContext } from '../../../../contexts/AccessCheckDropdownContext';
import { hasAllGates } from '../../../../utils/gatesCheckUtil';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_MAP = new Map();
export function AccessCheckDropdownShell({
  gates = [],
  dropdownProps,
  DropdownComponent,
  ContentComponent
}) {
  const hasAllRequiredGates = hasAllGates(gates);
  if (!hasAllRequiredGates) {
    return /*#__PURE__*/_jsx(AccessCheckDropdownContext.Provider, {
      value: {
        accessInfoMap: EMPTY_MAP,
        hasAllGates: false
      },
      children: /*#__PURE__*/_jsx(DropdownComponent, Object.assign({}, dropdownProps))
    });
  }
  return /*#__PURE__*/_jsx(ContentComponent, {
    dropdownProps: dropdownProps
  });
}